/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  InviteClientUserRequest,
  InviteClientUserResult,
  PortalClientUserDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List portal users under a client.
 */
export const adminClientUsersGetAdminClientsClientIdGuidUsers = (
  clientId: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalClientUserDto[]>(
    { url: `/admin/clients/${clientId}/users`, method: 'GET', signal },
    options,
  );
};

export const getAdminClientUsersGetAdminClientsClientIdGuidUsersQueryKey = (clientId?: string) => {
  return [`/admin/clients/${clientId}/users`] as const;
};

export const getAdminClientUsersGetAdminClientsClientIdGuidUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminClientUsersGetAdminClientsClientIdGuidUsersQueryKey(clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>
  > = ({ signal }) =>
    adminClientUsersGetAdminClientsClientIdGuidUsers(clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!clientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminClientUsersGetAdminClientsClientIdGuidUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>
>;
export type AdminClientUsersGetAdminClientsClientIdGuidUsersQueryError = unknown;

export function useAdminClientUsersGetAdminClientsClientIdGuidUsers<
  TData = Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
          TError,
          Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientUsersGetAdminClientsClientIdGuidUsers<
  TData = Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
          TError,
          Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminClientUsersGetAdminClientsClientIdGuidUsers<
  TData = Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List portal users under a client.
 */

export function useAdminClientUsersGetAdminClientsClientIdGuidUsers<
  TData = Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminClientUsersGetAdminClientsClientIdGuidUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminClientUsersGetAdminClientsClientIdGuidUsersQueryOptions(
    clientId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Seed a portal user for a client. Returns the temp password ONCE.
 */
export const adminClientUsersPostAdminClientsClientIdGuidUsers = (
  clientId: string,
  inviteClientUserRequest: InviteClientUserRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<InviteClientUserResult>(
    {
      url: `/admin/clients/${clientId}/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteClientUserRequest,
      signal,
    },
    options,
  );
};

export const getAdminClientUsersPostAdminClientsClientIdGuidUsersMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>,
    TError,
    { clientId: string; data: InviteClientUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>,
  TError,
  { clientId: string; data: InviteClientUserRequest },
  TContext
> => {
  const mutationKey = ['adminClientUsersPostAdminClientsClientIdGuidUsers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>,
    { clientId: string; data: InviteClientUserRequest }
  > = (props) => {
    const { clientId, data } = props ?? {};

    return adminClientUsersPostAdminClientsClientIdGuidUsers(clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminClientUsersPostAdminClientsClientIdGuidUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>
>;
export type AdminClientUsersPostAdminClientsClientIdGuidUsersMutationBody = InviteClientUserRequest;
export type AdminClientUsersPostAdminClientsClientIdGuidUsersMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Seed a portal user for a client. Returns the temp password ONCE.
 */
export const useAdminClientUsersPostAdminClientsClientIdGuidUsers = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>,
      TError,
      { clientId: string; data: InviteClientUserRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminClientUsersPostAdminClientsClientIdGuidUsers>>,
  TError,
  { clientId: string; data: InviteClientUserRequest },
  TContext
> => {
  const mutationOptions =
    getAdminClientUsersPostAdminClientsClientIdGuidUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
